// extracted by mini-css-extract-plugin
module.exports = {"meta":"detail_meta__KRh1a","content":"detail_content__3HvGD"};